export default "__VITE_ASSET__8721d91c__"